import styled, { createGlobalStyle } from 'styled-components';

import { fontFamilyBase, fontWeightMedium } from './typography.style';
import { LEGACY_ICON_CLASS } from 'approot/shared/icons/icon';
import { mediaUp } from 'approot/shared/style';
import { ReactModalCss } from 'lib/modal/modal.style';
import { PrintCss } from './print.style';
import { RebootCss } from './reboot.style';
import { ProductTourAnimationCss } from 'approot/shared/product-tours/product-tour-animation.style';

export const GlobalStyles = createGlobalStyle`
  /* Declare the cascade-layer order: our Bootstrap Reboot sits in the lowest
     layer, with Astryx's layers (reset -> astryx-base -> astryx-theme) above
     it, so Astryx styles win. Unlayered styles (e.g. styled-components) still
     take precedence over anything in a layer, as before. */
  @layer inq-reboot, reset, astryx-base, astryx-theme;

  html,
  body {
    font-family: ${fontFamilyBase};
    min-width: 280px;
  }

  html {
    min-height: 100%;
    color-scheme: light;
  }

  body {
    overflow-x: hidden;
  }

  strong {
    font-weight: ${fontWeightMedium};
  }

  /* Astryx's reset makes every replaced element a block
     (:where(img, svg, video, …) { display: block }), which is right for Astryx's
     own icons but wrong for our legacy ones — they were authored against the UA
     default and sit inline with text, so the reset breaks them onto their own
     line (breadcrumb arrows being the clearest case).

     Scoped to the class our shared Icon wrapper stamps, so it can only ever
     reach legacy icons, never an Astryx component. Deliberately unlayered —
     unlayered author styles outrank every layer, which is what lets this beat
     @layer reset — and wrapped in :where() so it carries zero specificity and
     any rule that sets display on purpose still wins. Net effect is to restore
     the pre-Astryx default, nothing more. */
  :where(svg.${LEGACY_ICON_CLASS}) {
    display: inline;
  }

  ${ReactModalCss}
  ${PrintCss}

  @layer inq-reboot {
    ${RebootCss}
  }

  ${ProductTourAnimationCss}
`;

export const ScreenReaderOnly = styled.div`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export const ScreenSmallOnlyStyled = styled.span`
  display: block;
  ${mediaUp.md`
    display: none;
  `}
`;

export const ScreenMediumOnlyStyled = styled.span`
  display: none;
  ${mediaUp.md`
    display: block;
  `}
`;
